import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const editPhonecentersMaintenance = ( {data, phonecentersMaintenanceId} : {data: IPostEditPhonecentersMaintenance | {}, phonecentersMaintenanceId: number}): Promise<string> => {
  return axiosDefaultApi.put(`/api/PhonecentersMaintenance/UpdatePhonecentersMaintenance/${phonecentersMaintenanceId}`, data);
};

type QueryFnType = typeof editPhonecentersMaintenance;

type UseEditPhonecentersMaintenanceOptions = {
  data: IPostEditPhonecentersMaintenance | {};
  phonecentersMaintenanceId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useEditPhonecentersMaintenance = ({ config }: UseEditPhonecentersMaintenanceOptions) => { 
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην επεξεργασία του Συντηρητή.`, 500);
            console.error('Couldnt edit PhonecentersMaintenance', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllPhonecentersMaintenances"])
            addNotification('Ο Συντηρητής Ενημερώθηκε.', 200);
            setIsNotificationVisible(true)
          },
        ...config,
        mutationFn: editPhonecentersMaintenance,
    })
}